module.exports = __webpack_public_path__ + "assets/img/site.2c081b2a.svg";